import React from 'react'
import { Helmet } from "react-helmet";
import '../styles/lyrics.css';
import { NavLink } from 'react-router-dom';

const Lyrics = () => {
  return (
    <div>
      <Helmet>
        <title>GAUSH - LYRICS</title>
      </Helmet>
      <section className="lyrics-catalog">
        <p style={{fontSize: '50px', color: '#ffffff', lineHeight: '90%', marginBottom: '60px'}}>LYRICS</p>
        <div className="lyrics-frames">
            <NavLink to="/lyrics/blew-up"><img src="/images/music/blewup.webp" style={{pointerEvents: 'none'}}/><p>BLEW UP</p></NavLink>
            <NavLink to="/lyrics/oh-my-gaush"><img src="/images/music/ohmygaush.webp" style={{pointerEvents: 'none'}}/><p>OH MY GAUSH</p></NavLink>
            <NavLink to="/lyrics/i-swear"><img src="/images/music/iswear.webp" style={{pointerEvents: 'none'}}/><p>I SWEAR</p></NavLink>
            <NavLink to="/lyrics/legendary"><img src="/images/music/legendary.webp" style={{pointerEvents: 'none'}}/><p>LEGENDARY</p></NavLink>
            <NavLink to="/lyrics/on-my-mind"><img src="/images/music/onmymind.webp" style={{pointerEvents: 'none'}}/><p>ON MY MIND</p></NavLink>
            <NavLink to="/lyrics/kaun-hai"><img src="/images/music/kaunhai.webp" style={{pointerEvents: 'none'}}/><p>KAUN HAI?</p></NavLink>
            <NavLink to="/lyrics/xix-freeverse"><img src="/images/music/xixfreeverse.webp" style={{pointerEvents: 'none'}}/><p>XIX FREEVERSE</p></NavLink>
            <NavLink to="/lyrics/gods-work"><img src="/images/music/godswork.webp" style={{pointerEvents: 'none'}}/><p>GOD'S WORK</p></NavLink>
            <NavLink to="/lyrics/beete-lamhe"><img src="/images/music/beetelamhe.webp" style={{pointerEvents: 'none'}}/><p>BEETE LAMHE</p></NavLink>
            <NavLink to="/lyrics/forever-alive"><img src="/images/music/foreveralive.webp" style={{pointerEvents: 'none'}}/><p>FOREVER ALIVE</p></NavLink>
            <NavLink to="/lyrics/future-superstar"><img src="/images/music/futuresuperstar.webp" style={{pointerEvents: 'none'}}/><p>FUTURE SUPERSTAR</p></NavLink>
            <NavLink to="/lyrics/roshni"><img src="/images/music/roshni.webp" style={{pointerEvents: 'none'}}/><p>ROSHNI</p></NavLink>
            <NavLink to="/lyrics/22-freestyle"><img src="/images/music/22freestyle.webp" style={{pointerEvents: 'none'}}/><p>22 FREESTYLE</p></NavLink>
            <NavLink to="/lyrics/wo-kehti-thi"><img src="/images/music/wokehtithi.webp" style={{pointerEvents: 'none'}}/><p>WO KEHTI THI</p></NavLink>
        </div>
    </section>
      
      </div>
  )
}

export default Lyrics